// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-tabs {
  display: flex;
  gap: 2px;
  padding: 0 24px;
  border-bottom: 1px solid var(--border);
  background: var(--bg);
}

.page-tabs .ptab {
  padding: 12px 14px;
  font-size: var(--fs-ui);
  font-family: var(--sans);
  color: var(--text-muted);
  background: transparent;
  border: none;
  cursor: pointer;
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: color 100ms ease;
}

.page-tabs .ptab:hover {
  color: var(--text-secondary);
}

.page-tabs .ptab.active {
  color: var(--text);
}

.page-tabs .ptab.active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 2px;
  background: var(--signal);
}

.page-tabs .ptab .count {
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  color: var(--text-muted);
  background: var(--bg-alt);
  border: 1px solid var(--border);
  border-radius: var(--radius-full);
  padding: 1px 7px;
}

.page-tabs .ptab--locked {
  opacity: 0.55;
  cursor: not-allowed;
}

.page-tabs .ptab--locked:hover {
  color: var(--text-muted);
}

.page-tabs .ptab__prox {
  font-family: var(--mono);
  font-size: var(--fs-pico);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--cream-deep, #a07717);
  background: rgba(242, 227, 181, 0.18);
  padding: 1px 5px;
  border-radius: 2px;
}

[data-theme='dark'] .page-tabs {
  background: var(--bg);
  border-color: var(--border);
}

[data-theme='dark'] .page-tabs .ptab {
  color: var(--text-muted);
}

[data-theme='dark'] .page-tabs .ptab:hover {
  color: var(--text-secondary);
}

[data-theme='dark'] .page-tabs .ptab.active {
  color: var(--text);
}

[data-theme='dark'] .page-tabs .ptab .count {
  color: var(--text-muted);
  background: var(--bg-alt);
  border-color: var(--border);
}
`, "",{"version":3,"sources":["webpack://./src/ui/Tabs/Tabs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;EACzB,+BAA+B;EAC/B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,iCAAiC;EACjC,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;AAC7B","sourcesContent":[".page-tabs {\n  display: flex;\n  gap: 2px;\n  padding: 0 24px;\n  border-bottom: 1px solid var(--border);\n  background: var(--bg);\n}\n\n.page-tabs .ptab {\n  padding: 12px 14px;\n  font-size: var(--fs-ui);\n  font-family: var(--sans);\n  color: var(--text-muted);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: color 100ms ease;\n}\n\n.page-tabs .ptab:hover {\n  color: var(--text-secondary);\n}\n\n.page-tabs .ptab.active {\n  color: var(--text);\n}\n\n.page-tabs .ptab.active::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -1px;\n  height: 2px;\n  background: var(--signal);\n}\n\n.page-tabs .ptab .count {\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  color: var(--text-muted);\n  background: var(--bg-alt);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-full);\n  padding: 1px 7px;\n}\n\n.page-tabs .ptab--locked {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.page-tabs .ptab--locked:hover {\n  color: var(--text-muted);\n}\n\n.page-tabs .ptab__prox {\n  font-family: var(--mono);\n  font-size: var(--fs-pico);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--cream-deep, #a07717);\n  background: rgba(242, 227, 181, 0.18);\n  padding: 1px 5px;\n  border-radius: 2px;\n}\n\n[data-theme='dark'] .page-tabs {\n  background: var(--bg);\n  border-color: var(--border);\n}\n\n[data-theme='dark'] .page-tabs .ptab {\n  color: var(--text-muted);\n}\n\n[data-theme='dark'] .page-tabs .ptab:hover {\n  color: var(--text-secondary);\n}\n\n[data-theme='dark'] .page-tabs .ptab.active {\n  color: var(--text);\n}\n\n[data-theme='dark'] .page-tabs .ptab .count {\n  color: var(--text-muted);\n  background: var(--bg-alt);\n  border-color: var(--border);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
